export const AUTOMOTIVE_META_DESCRIPTION_BG =
  "Медиен мониторинг и медийни анализи за автомобилни брандове в Югоизточна Европа - премиери, изтегляния, дилърска мрежа и анализ на репутацията.";
